module.exports = __webpack_public_path__ + "static/media/IAQAnalytics3.c60a53d7.png";